"use client";

import { c as _c } from "react/compiler-runtime";
import { Typography } from "@/shared/ui/atoms";
import Image from "next/image";
import { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { PartnerHospitalMainImage } from "@/entities/hospital/api/types";
interface ImageSlideProps {
  images: PartnerHospitalMainImage[];
}
const ImageSlide = t0 => {
  const $ = _c(13);
  const {
    images
  } = t0;
  const [isMounted, setIsMounted] = useState(false);
  const [activeIndex, setActiveIndex] = useState(0);
  const validImages = images.filter(_temp);
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      setIsMounted(true);
    };
    t2 = [];
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  useEffect(t1, t2);
  if (validImages.length === 0) {
    return null;
  }
  const t3 = "partner-hospital-image-slide dynamic-aspect-375-160 w-full overflow-hidden";
  const t4 = !isMounted ? <div className="h-full w-full bg-gray-100" /> : <Swiper className="h-full w-full" loop={validImages.length > 1} onSlideChange={swiper => {
    setActiveIndex(swiper.realIndex ?? swiper.activeIndex ?? 0);
  }}>{validImages.map(_temp2)}</Swiper>;
  const t5 = activeIndex + 1;
  let t6;
  if ($[2] !== t5) {
    t6 = <Typography as="span" size={12} lineHeight={14} className="text-semibold text-white">{t5}</Typography>;
    $[2] = t5;
    $[3] = t6;
  } else {
    t6 = $[3];
  }
  let t7;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <span className="w-2 h-2 flex items-center justify-center text-semibold text-gray-500">・</span>;
    $[4] = t7;
  } else {
    t7 = $[4];
  }
  let t8;
  if ($[5] !== validImages.length) {
    t8 = <Typography as="span" size={12} lineHeight={14} className="text-semibold text-gray-300">{validImages.length}</Typography>;
    $[5] = validImages.length;
    $[6] = t8;
  } else {
    t8 = $[6];
  }
  let t9;
  if ($[7] !== t6 || $[8] !== t8) {
    t9 = <div className="absolute bottom-[14px] right-3 z-10 flex items-center gap-[3px] rounded-full bg-[rgba(26,26,31,0.80)] px-2 py-1">{t6}{t7}{t8}</div>;
    $[7] = t6;
    $[8] = t8;
    $[9] = t9;
  } else {
    t9 = $[9];
  }
  let t10;
  if ($[10] !== t4 || $[11] !== t9) {
    t10 = <div className={t3}>{t4}{t9}</div>;
    $[10] = t4;
    $[11] = t9;
    $[12] = t10;
  } else {
    t10 = $[12];
  }
  return t10;
};
export default ImageSlide;
function _temp(img) {
  return img.url?.trim();
}
function _temp2(image, index) {
  return <SwiperSlide key={`partner-hospital-image-${index}`} className="!h-full"><div className="relative h-full w-full"><Image src={image.url} alt={`Partner Hospital Image ${image.id}`} fill={true} sizes="(max-width: 600px) 100vw, 600px" className="object-cover" priority={true} /></div></SwiperSlide>;
}